import React, { Component } from 'react'
import { CustomModal } from './Modal'
import { helpLink, helpVuCourseLink } from '../../../helpers/links';
import { getAttributeCourseStaticInfo } from '../../../helpers/enrolment'
import { renderCUA, renderCourseStructure, renderError } from '../../../helpers/errors';

class ErrorModal extends Component {

    renderErrors = () => {
        let returnResults =[];
        let enrolmentErrors = this.props.enrolmentErrors

        if (!enrolmentErrors) {
            return null;
        }

        enrolmentErrors
            .filter(error => error.apiErrorCode !== this.props.genericErrorCode)
            .map((error, index) => {
                returnResults.push(renderError(error, `non_generic_error_${index}`))
            })

        let genericCodeError = enrolmentErrors.find(error => {
            return error.apiErrorCode === this.props.genericErrorCode;
        })

        if (genericCodeError) {
            returnResults.push(renderError(genericCodeError, `generic_error_0`))
        }

        if (this.props.renderCourseStruture) {
            returnResults.push(renderCourseStructure('course_stcuture_0'))
        }

        if (this.props.renderCourseCUA) {
            returnResults.push(renderCUA)
        }

        return returnResults
    }

    render() {
        if (!this.props.isOpen) {
          return null
        }

        return (
            <CustomModal
              isOpen={this.props.isOpen}
              handleCloseModal={() => this.props.handleCloseModal()}
              title={this.props.title}
              className={this.props.className}
            >
                {this.props.processErrors && this.renderErrors()}
                {this.props.children && this.props.children}
            </CustomModal>
        );
    }
}

export default ErrorModal